const stats = [
  { num: "1M+", label: "People Inspired Live" },
  { num: "30+", label: "Years On Stage" },
  { num: "3", label: "Published Books" },
  { num: "500+", label: "Events Delivered" },
];

export default function StatsBand() {
  return (
    <section data-testid="stats-band" className="relative bg-[#EC1985] py-12 md:py-16 border-y border-black">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-10">
        {stats.map((s) => (
          <div key={s.label} data-testid={`stat-${s.label.replace(/ /g, '-').toLowerCase()}`} className="text-left">
            <div className="font-display text-5xl md:text-7xl text-white leading-none">{s.num}</div>
            <div className="mt-2 text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-white/90">
              {s.label}
            </div>
          </div>
        ))}
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-10 pt-8 border-t border-white/20">
        <p
          data-testid="reach-line"
          className="text-center text-white/95 text-sm md:text-base font-bold uppercase tracking-[0.25em]"
        >
          Delivered Nationwide & Internationally
        </p>
      </div>
    </section>
  );
}
